import "./CardSocialLink.css.ts.vanilla.js";
var a = "q6crdlg", c = "q6crdlh", d = "q6crdl0", l = "q6crdl1", t = "q6crdlb", v = "q6crdlc", e = "q6crdl6", q = "q6crdla", i = "q6crdl3", n = "q6crdl5", o = "q6crdl4", k = "q6crdld", u = "q6crdle", g = "q6crdlf", m = "q6crdl7", b = "q6crdl8", h = "q6crdl9", p = "q6crdl2";
export {
  a as backgroundGrey,
  c as backgroundWhite,
  d as cardSocialLink,
  l as cardSocialLinkBorder,
  t as ctaButton,
  v as ctaIcon,
  e as details,
  q as handle,
  i as icon,
  n as iconComponent,
  o as iconImage,
  k as isEditMode,
  u as textDark,
  g as textOnAccent,
  m as title,
  b as titleDefault,
  h as titleSmall,
  p as visuallyHidden
};
